import React, { useEffect, useRef, useState } from "react";
import { GET_MYPROFILE } from "../Utils/appConstants";
import { getRequest } from "../Utils/AppApi";
import { useHistory } from "react-router-dom";
import logo from "../assets/app_icon.png";
import appLogo from "../assets/logo_in_bg.png";
import "./MerchantCertificate.css";

function MerchantCertificate() {
  const history = useHistory();
  const [profile, setProfile] = useState({});
  const [detail, setDetail] = useState({});
  const [isPrintButton, setPrintButton] = useState(true);

  const getProfile = () => {
    getRequest(GET_MYPROFILE, history).then((response) => {
      if (response.success === true) {
        const data = response.data[0];
        setProfile(data);
        setDetail(data.userdetail);
      }
    });
  };

  useEffect(() => {
    getProfile();
  }, []);

  const formatDate = (date) => {
    return new Date(date)
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
      .toUpperCase();
  };

  const today = formatDate(new Date());

  // Print function (same pattern as Invoice component)
  const handlePrint = () => {
    setPrintButton(false);
    setTimeout(() => {
      window.print();
      setPrintButton(true);
    }, 100);
  };

  return (
    <div className="container mt-4">
      {/* Print button (centered) */}

      {/* Certificate content */}
      <div className="certificate-wrapper">
        <div className="certificate-box">
          <div className="inner-border"></div>
          <div className="background-pattern"></div>

          {/* Watermark logo */}
          <div className="watermark-logo">
            <img src={appLogo} alt="" />
          </div>

          <div className="certificate-header">
            <img src={logo} alt="SR Pay" className="certificate-logo" />
            <h2 className="certificate-title">BC Agent / Merchant Certificate</h2>
          </div>

          <div className="certificate-body">
            <p className="merchant-id">
              Merchant ID: <b>{detail?.outletId}</b>
            </p>

            <p className="certify-line">This is to certify that Mr./Ms.</p>
            <h3 className="merchant-name">{profile?.name}</h3>
            <p className="parentage-line">
              S/o <b>{detail?.fatherName || "__________"}</b> , R/o
            </p>
            <p className="address-line">{detail?.registeredAddress}</p>

            <p className="certificate-paragraph">
              has been on-boarded as a BC Agent (“Merchant”) of{" "}
              <b>SR PAY Private Limited</b> with effect from{" "}
              <b>{profile?.createdAt ? formatDate(profile.createdAt) : ""}</b>
              , for providing various financial technology services (Under BC Model),
              e-commerce services etc, as available on the portal of the Company
              namely <b>‘www.srpay1.com’</b> and SRPAY Mobile Application subject
              to terms and conditions as mentioned and accepted by said Merchant
              on the aforesaid platform.
            </p>

            <div className="company-name">
              SR PAY Private Limited
              <span className="stamp-star">★</span>
            </div>

            <p className="certificate-note">
              This is an auto-generated certificate and does not require signature.
              This certificate has been downloaded on <b>{today}</b> by downloading
              by above Merchant from aforesaid Portal/Mobile App and is valid till{" "}
              <b>31st March, 2026</b>.
              <br />
              Any misuse of this Certificate is strictly prohibited.
            </p>
          </div>
        </div>
      </div>

      <div className="text-center">
        <button
          className="btn btn-print mb-3"
          onClick={handlePrint}
          disabled={!isPrintButton}
        >
          Print Certificate
        </button>
      </div>

    </div>
  );
}

export default MerchantCertificate;